let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lmnT6")).then(() => parcelRequire('fceYi'));